import React from "react";
import styled from "styled-components";
import { theme, Colors } from "../../theme";

import { ReactComponent as logoGlobo } from "./logo-globo.svg";
import { ReactComponent as contaGlobo } from "./conta-globo.svg";

type Variant = "logo" | "conta";

export interface GloboProps extends React.ComponentPropsWithoutRef<"svg"> {
  variant: Variant;
  height?: number;
  width?: number;
}

type StyledProps = Pick<GloboProps, "height" | "width">;

const StyledLogo = styled.svg<StyledProps>`
  height: ${({ height }) => (height ? `${height}px` : "auto")};
  width: ${({ width }) => (width ? `${width}px` : "auto")};

  path {
    fill: ${theme(Colors.blue[100], Colors.white)};
  }
`;

const variants = {
  logo: {
    svg: logoGlobo,
    title: "Globo"
  },
  conta: {
    svg: contaGlobo,
    title: "Conta Globo"
  }
};

export function Globo(props: GloboProps) {
  const { variant, ...htmlProps } = props;
  const { svg, title } = variants[variant];

  return <StyledLogo as={svg} role="img" title={title} {...htmlProps} />;
}

export default Globo;
